import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IDropdownResponse,
  ITerritoriesResponse,
  ITerritoryDetail,
  ITerritoryPost
} from '../models';

export const getTerritories = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
  hasSpecs?: boolean;
}): Promise<ITerritoriesResponse> => {
  try {
    const { data } = await axios.get(`/api/territories`, {
      params: filters
    });
    return data;

  } catch (error) {
    logError(error, 'getTerritories failed');
    return Promise.reject(error);
  }
};

export const createTerritory = async (post: ITerritoryPost): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/territories`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'createTerritory failed');
    return Promise.reject(error.response.data);
  }
};

export const getTerritory = async (id): Promise<ITerritoryDetail> => {
  try {
    const { data } = await axios.get(`/api/territories/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getTerritory failed');
    return Promise.reject(error);
  }
};

export const deleteTerritory = async (id): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/territories/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteTerritory failed');
    return Promise.reject(error);
  }
};

export const updateTerritory = async (id, put: ITerritoryPost): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/territories/${id}`, put);
    return data;
  } catch (error) {
    logError({ error, payload: { id, put } }, 'updateTerritory failed');
    return Promise.reject(error.response.data);
  }
};

export const getTerritoryImages = async (id: number): Promise<string[]> => {
  try {
    const { data } = await axios.get(`/api/territories/${id}/images`);
    return data;
  } catch (error) {
    logError(error, 'getTerritoryImages failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createTerritoryImages = async (id, image: FormData): Promise<string[]> => {
  try {
    const { data } = await axios.post(`/api/territories/${id}/images`, image);
    return data;
  } catch (error) {
    logError({ error, payload: { id, image } }, 'createTerritoryImages failed');
    return Promise.reject(error);
  }
};

export const getTerritoryPersonnelTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/territories/personnel-types`);
    return data;
  } catch (error) {
    logError(error, 'getTerritoryPersonnelTypes failed');
    return Promise.reject(error);
  }
};
